import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IRelatorioInformaticaResponseData } from 'src/app/interfaces/relatorio/Informatica/IRelatorioInformaticaResponseData';
import { RelatorioInformaticaService } from 'src/app/services/relatorios/informatica/relatorio-informatica.service';
import { ETipoRelatorio } from 'src/app/enums/relatorios/ETipoRelatorio.enum';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-relatorio-informatica',
  templateUrl: './relatorio-informatica.component.html',
  styleUrls: ['./relatorio-informatica.component.scss']
})
export class RelatorioInformaticaComponent implements OnInit {
  private subscriptions$ = new Subscription();
  relatorio: IRelatorioInformaticaResponseData;
  codigoContrato: string;
  mesAno: string;
  constructor(
    private relatorioInformaticaService: RelatorioInformaticaService,
    private route: ActivatedRoute
  ) {}

  getDadosRelatorioInformatica() {
    this.subscriptions$.add(
      this.relatorioInformaticaService
        .postRelatorioInformatica({
          codigoContrato: this.codigoContrato,
          mesReferencia: this.mesAno,
          tipoExportacao: ETipoRelatorio.PDF
        })
        .subscribe({
          next: ({ data }) => {
            this.relatorio = data;
          }
        })
    );
  }
  ngOnInit() {
    this.route.params.subscribe(
      (params) => (
        (this.codigoContrato = params['codContrato']),
        (this.mesAno = params['mesAno'])
      )
    );
    this.getDadosRelatorioInformatica();
  }
}
